// extracted by mini-css-extract-plugin
module.exports = {"worst":"#00516c","bad":"#008495","neutral":"#00c7d5","good":"#00fffd","best":"#c9ffff","missing":"rgba(0,0,0,0)","notApplicable":"#bbc0d2"};